import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Partials/Footer";
import Header from "../components/Partials/Header";

const DefaultLayout = ({ setShow }) => {
  return (
    <>
      <Header setShow={setShow} />
      <Outlet />
      <Footer />
    </>
  );
};

export default DefaultLayout;
